import { useState, useCallback } from 'react';
import { Colors } from '../ColorSelect';
import type { TagFormData } from './TagFormContext';
import { TagFormContext } from './TagFormContext';

type Props = {
  defaultState?: TagFormData;
  children: React.ReactNode;
};

const DefaultState: TagFormData = {
  title: '',
  parentId: null,
  category: null,
  includeSummary: true,
  color: Colors.defaultColor,
};

export const TagFormContainer = ({ children, defaultState = DefaultState }: Props) => {
  const [state, setState] = useState<TagFormData>(defaultState);

  const updateState = useCallback((data: Partial<TagFormData>) => {
    setState((old) => ({ ...old, ...data }));
  }, []);

  return (
    <TagFormContext.Provider value={{ data: state, dispatch: updateState }}>
      {children}
    </TagFormContext.Provider>
  );
};
